/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unescaped-entities */

import React from "react";

const PrivacyPage: React.FC = () => {
  return (
    <main className="max-w-4xl mx-auto px-4 py-12 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-2">
        Política de Privacidade – Cordas e Música
      </h1>

      <p className="text-sm text-gray-500 mb-6">
        Última atualização: 10/12/2025
      </p>

      <p className="mb-4">
        Esta Política de Privacidade explica como o aplicativo e o site{" "}
        <strong>Cordas e Música</strong> tratam informações sobre você e o seu
        dispositivo. Ao utilizar nossos serviços, você concorda com os termos
        descritos abaixo.
      </p>

      {/* 1. Quem somos */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">1. Quem somos</h2>
      <p className="mb-3">
        O <strong>Cordas e Música</strong> é um projeto educacional voltado para
        o ensino de música, disponibilizando conteúdos, ferramentas como
        afinador, metrônomo e outros recursos relacionados.
      </p>

      {/* 2. Quais dados coletamos */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        2. Quais dados coletamos
      </h2>

      <h3 className="text-lg font-semibold mt-4 mb-2">
        2.1. Dados fornecidos por você
      </h3>
      <p className="mb-2">
        Em geral, o app não exige cadastro para utilização das funções básicas
        (como afinador e metrônomo). Caso você entre em contato conosco por
        e-mail ou formulários, poderemos coletar:
      </p>
      <ul className="list-disc list-inside mb-3">
        <li>Nome;</li>
        <li>E-mail;</li>
        <li>Informações que você incluir na sua mensagem.</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4 mb-2">
        2.2. Dados coletados automaticamente
      </h3>
      <p className="mb-2">
        Podemos coletar informações técnicas e de uso de forma automática e
        agregada, como:
      </p>
      <ul className="list-disc list-inside mb-3">
        <li>Modelo do dispositivo e sistema operacional;</li>
        <li>Versão do aplicativo;</li>
        <li>Logs de erro e dados de desempenho do app;</li>
        <li>
          Informações genéricas de navegação, como quais telas são mais
          acessadas e tempo de uso.
        </li>
      </ul>
      <p className="mb-4">
        Esses dados são utilizados para estatísticas, correção de erros e
        melhoria do serviço, sem identificar usuários individualmente.
      </p>

      {/* 3. Permissões */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        3. Permissões utilizadas pelo aplicativo
      </h2>
      <p className="mb-2">
        Algumas funcionalidades podem solicitar permissões do seu dispositivo:
      </p>
      <ul className="list-disc list-inside mb-3">
        <li>
          <strong>Microfone</strong>: utilizado apenas para as funções de
          afinador e recursos de áudio, quando disponíveis.
        </li>
        <li>
          <strong>Acesso à internet</strong>: para carregar conteúdos on-line,
          atualizar dados e exibir material hospedado em serviços de terceiros
          (por exemplo, vídeos).
        </li>
      </ul>
      <p className="mb-4">
        As permissões são usadas exclusivamente para o funcionamento dessas
        funcionalidades e podem ser gerenciadas nas configurações do seu
        dispositivo.
      </p>

      {/* 4. Cookies e tecnologias semelhantes */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        4. Cookies e tecnologias semelhantes
      </h2>
      <p className="mb-4">
        No app, o <strong>Cordas e Música</strong> não utiliza cookies. No site,
        podem ser utilizados cookies de sessão para funcionalidades básicas e
        cookies de terceiros para estatísticas de acesso (por exemplo,
        ferramentas de análise de tráfego).
      </p>

      {/* 5. Como usamos seus dados */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        5. Como usamos seus dados
      </h2>
      <p className="mb-2">Utilizamos os dados coletados para:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Permitir o funcionamento do app e do site;</li>
        <li>Melhorar a experiência de uso;</li>
        <li>Corrigir falhas, erros e problemas de desempenho;</li>
        <li>Responder contatos e dúvidas enviados pelos canais de suporte.</li>
      </ul>

      {/* 6. Compartilhamento de dados */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        6. Compartilhamento de dados
      </h2>
      <p className="mb-2">
        Não vendemos nem compartilhamos seus dados pessoais com terceiros para
        fins de marketing. Seus dados poderão ser compartilhados apenas:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          Com prestadores de serviço que nos ajudam a operar a infraestrutura
          (por exemplo, hospedagem de site, serviços de e-mail ou análise de
          erros);
        </li>
        <li>
          Quando exigido por lei, decisão judicial ou autoridade competente.
        </li>
      </ul>

      {/* 7. Segurança */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        7. Segurança das informações
      </h2>
      <p className="mb-4">
        Adotamos medidas razoáveis de segurança para proteger os dados contra
        acessos não autorizados, perda, uso indevido ou alteração indevida. Ainda
        assim, nenhum sistema é completamente seguro, e não podemos garantir
        segurança absoluta.
      </p>

      {/* 8. Direitos do titular (LGPD) */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        8. Seus direitos (LGPD e legislações aplicáveis)
      </h2>
      <p className="mb-2">
        De acordo com a Lei Geral de Proteção de Dados (LGPD) e demais
        legislações de privacidade, você pode ter direito a:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Acessar os dados pessoais que mantemos sobre você;</li>
        <li>Solicitar correção de dados incompletos, inexatos ou desatualizados;</li>
        <li>Solicitar a exclusão de dados, quando aplicável;</li>
        <li>Revogar consentimentos concedidos, quando a base for consentimento.</li>
      </ul>
      <p className="mb-4">
        Caso queira exercer algum desses direitos, entre em contato pelos canais
        indicados abaixo.
      </p>

      {/* 9. Contato */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">9. Contato</h2>
      <p className="mb-4">
        Em caso de dúvidas sobre esta Política de Privacidade ou sobre o
        tratamento de dados pessoais, você pode entrar em contato pelo e-mail:{" "}
        <a
          href="mailto:suporte@cordasemusica.com.br"
          className="text-blue-600 underline"
        >
          suporte@cordasemusica.com.br
        </a>
        .
      </p>

      {/* 10. Alterações */}
      <h2 className="text-2xl font-semibold mt-6 mb-3">
        10. Alterações nesta Política
      </h2>
      <p className="mb-4">
        Esta Política de Privacidade pode ser atualizada periodicamente para
        refletir melhorias no app, ajustes legais ou mudanças em nossos
        processos. A versão atualizada será sempre publicada nesta página,
        indicando a data da última atualização.
      </p>
    </main>
  );
};

export default PrivacyPage;
